/*
 * @Description: 项目相关
 * @Date: 2025-03-03 11:38:40
 */
/**
 * 交易结构：1 汇总申报，3 委托代发，4 运营基地，5 个体产品，6 委托代开
 */
export enum TaxPatternEnum {
  one = 1, // 汇总申报
  three = 3, // 委托代发
  four = 4, // 运营基地
  five = 5, // 个体产品
  six = 6 // 委托代开
}

/**
 * 参与方
 */
export const patternTypeMapping = {
  1: { label: '工业-ASP-P-C', value: 1 },
  2: { label: '工业-P-C', value: 2 },
  // 3: { label: 'ASP-P-C', value: 3 },
  4: { label: '工业-ASP-C', value: 4 },
  5: { label: '工业-C', value: 5 },
  // 6: { label: 'ASP-C', value: 6 },
  // 7: { label: '工业-运营基地-C', value: 7 },
  7: { label: '工业-ASP-C', value: 7 },
  // 8: { label: 'ASP-运营基地-C ', value: 8 },
  // 9: { label: '运营基地-C', value: 9 },
  10: { label: '工业-ASP-个体', value: 10 },
  11: { label: '工业-个体', value: 11 }
  // 12: { label: 'ASP-个体', value: 12 },
  // 13: { label: '工业-ASP（线下支付）-P-C', value: 13 },
  // 14: { label: '工业（线下支付）-P-C', value: 14 }
};

/**
 * 交易结构：1 汇总申报（工业-ASP-P-C，工业-P-C），4 运营基地（工业-运营基地-C），3 委托代发（工业-ASP-P-C，工业-P-C），6 委托代开（工业-ASP-C，工业-C），5 个体产品（工业-ASP-个体，工业-个体）
 */
export const taxPatternMapping: Record<
  TaxPatternEnum,
  {
    value: TaxPatternEnum;
    label: string;
    patternsMapping: Record<
      number,
      {
        value: number;
        label: string;
      }
    >;
  }
> = {
  [TaxPatternEnum.one]: {
    value: TaxPatternEnum.one,
    label: '汇总申报',
    patternsMapping: {
      1: patternTypeMapping[1],
      2: patternTypeMapping[2]
    }
  },
  [TaxPatternEnum.four]: {
    value: TaxPatternEnum.four,
    label: '运营基地',
    patternsMapping: {
      7: patternTypeMapping[7],
      5: patternTypeMapping[5]
    }
  },
  [TaxPatternEnum.three]: {
    value: TaxPatternEnum.three,
    label: '委托代发',
    patternsMapping: {
      1: patternTypeMapping[1],
      2: patternTypeMapping[2]
    }
  },
  [TaxPatternEnum.six]: {
    value: TaxPatternEnum.six,
    label: '委托代开',
    patternsMapping: {
      4: patternTypeMapping[4],
      5: patternTypeMapping[5]
    }
  },
  [TaxPatternEnum.five]: {
    value: TaxPatternEnum.five,
    label: '个体产品',
    patternsMapping: {
      10: patternTypeMapping[10],
      11: patternTypeMapping[11]
    }
  }
};

/**
 * 交易结构：1 汇总申报（工业-ASP-P-C，工业-P-C），4 运营基地（工业-运营基地-C），3 委托代发（工业-ASP-P-C，工业-P-C），6 委托代开（工业-ASP-C，工业-C），5 个体产品（工业-ASP-个体，工业-个体）
 */
export const taxPatternArr = [
  {
    value: TaxPatternEnum.one,
    label: '汇总申报',
    patternsArr: [patternTypeMapping[1], patternTypeMapping[2]]
  },
  {
    value: TaxPatternEnum.four,
    label: '运营基地',
    patternsArr: [patternTypeMapping[7], patternTypeMapping[5]]
  },
  {
    value: TaxPatternEnum.three,
    label: '委托代发',
    patternsArr: [patternTypeMapping[1], patternTypeMapping[2]]
  },
  {
    value: TaxPatternEnum.six,
    label: '委托代开',
    patternsArr: [patternTypeMapping[4], patternTypeMapping[5]]
  },
  {
    value: TaxPatternEnum.five,
    label: '个体产品',
    patternsArr: [patternTypeMapping[10], patternTypeMapping[11]]
  }
];

/**
 * 场景类型：6：数字专区（专区+资讯），21：数字问卷（专区+资讯+表单），17：数字拜访（专区+资讯+目标题+固定字段），5：调研问卷（表单），20：可配置（表单+目标题+风控题），19：协定服务（固定字段+特殊计价）
 */
export enum SceneTypeEnum {
  six = 6,
  twentyOne = 21,
  seventeen = 17,
  five = 5,
  twenty = 20,
  nineteen = 19
}

/**
 * 场景类型：6：数字专区（专区+资讯），21：数字问卷（专区+资讯+表单），17：数字拜访（专区+资讯+目标题+固定字段），5：调研问卷（表单），20：可配置（表单+目标题+风控题），19：协定服务（固定字段+特殊计价）
 */
export const sceneTypeMapping = {
  [SceneTypeEnum.six]: { label: '数字专区', value: SceneTypeEnum.six },
  [SceneTypeEnum.twentyOne]: {
    label: '数字问卷',
    value: SceneTypeEnum.twentyOne
  },
  [SceneTypeEnum.seventeen]: {
    label: '数字拜访',
    value: SceneTypeEnum.seventeen
  },
  [SceneTypeEnum.five]: {
    label: '调研问卷',
    value: SceneTypeEnum.five
  },
  [SceneTypeEnum.twenty]: {
    label: '可配置',
    value: SceneTypeEnum.twenty
  },
  [SceneTypeEnum.nineteen]: {
    label: '协定服务',
    value: SceneTypeEnum.nineteen
  }
};

/**
 * 劳务类型：1经营类， 2劳务类 一般劳务， 3劳务类 连续劳务
 */
export const taxTypeMapping = {
  1: {
    value: 1,
    label: '经营类'
  },
  2: {
    value: 2,
    label: '一般劳务'
  },
  3: {
    value: 3,
    label: '连续劳务'
  }
};

/**
 * 劳务类型综合类型：1经营类， 2劳务类
 */
export const taxBroadTypeMapping = {
  1: {
    value: 1,
    label: '经营类'
  },
  2: {
    value: 2,
    label: '劳务类'
  }
};
